module.exports = __webpack_public_path__ + "media/images/about__join-the-team-md-e9ddcdb192649f267c54888a1e48eeaa.jpg";